import EditPripomienkaPage from './EditPripomienkaPage';

export default EditPripomienkaPage;
